module.exports = __webpack_public_path__ + "img/welcome_banner.c0ac389c.png";